import { bridge, xenv } from '@didi/webx-js'
import { EnumLang } from '../defines/enums'
import { URLQueries } from './url_query'

const getLanguageByBridge = () =>
  new Promise(resolve =>
    ['passenger', 'hypassenger'].includes(xenv())
      ? bridge.getSystemInfo({}, res =>
          resolve(
            Object.values(EnumLang).indexOf(res?.lang) > -1 ? res.lang : ''
          )
        )
      : resolve('')
  )

const getLanguageByQuery = () =>
  Object.values(EnumLang).indexOf(URLQueries.getQuery('lang')) > -1
    ? URLQueries.getQuery('lang')
    : ''

/**
 * 获取语言配置
 * @return {('en-US' | 'zh-CN' | 'zh-HK')}
 */
export const getLanguageConfig = async () => {
  // 兼容整合营销调过来，优先读取query上的
  const res0 = getLanguageByQuery()
  if (res0) return res0
  const res1 = await getLanguageByBridge()
  if (res1) return res1
  return EnumLang['zh-CN']
}

/**
 * 设置 i18n 系统当前语言
 * @param {('en-US' | 'zh-CN' | 'zh-HK')} lang - 语言
 */
export const setI18n = lang => {
  window.__mpx.i18n.locale = lang
}
